import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faYelp } from '@fortawesome/free-brands-svg-icons';
import Map from "./Location";
import logo from "../img/logo.jpeg";
import ServiceListFooter from "./Service-Footer";
import AreaList from "../common/Area-list";

const Footer = () => {
    return (
        <div>
            <ul className="areaFooter">
                <div className="heading_container" style={{"align-items": "center"}}>
                    <h2> Our <span>Locations</span> </h2>
                    <br />
                </div>
                <AreaList />
            </ul>
            
            <section className="info_section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6 col-lg-3 info_col">
                            <div className="info_detail">
                                <a className="footer-logo" href="/" data-discover="true">
                                    <img src={logo} />
                                </a>
                                <p>At Golden State Movers, we specialize in local and long-distance moves, offering comprehensive solutions that include packing, loading, transportation, and unpacking.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-2 info_col">
                            <div className="info_link_box">
                                <h4>Links</h4>
                                <div className="info_links">
                                    <Link to="/">Home</Link>
                                    <Link to="/about">About</Link>
                                    <Link to="/services">Services</Link>
                                    <Link to="/contact">Contact Us</Link>
                                    <Link to="/privacy-policy">Privacy Policy</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-2 info_col">
                            <div className="info_link_box">
                                <h4>Services</h4>
                                <div className="info_links">
                                    <ServiceListFooter />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3 info_col">
                            <div className="info_contact">
                                <h4>Address</h4>
                                <div className="contact_link_box">
                                    <Link to="tel:+01123455678990">
                                        <FontAwesomeIcon icon={faPhone} />
                                        <span> +1 408-215-6348  </span>
                                    </Link>
                                    <Link to="mailto:info@goldenstatemover.com">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                        <span> info@goldenstatemover.com </span>
                                    </Link>
                                    <Link to="/">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        <span> 9361 Jackson Road, Sacramento  CA 95826 </span>
                                    </Link>
                                    <Link to="/">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        <span> 1859 Masuda Landing, San Jose CA 95132 </span>
                                    </Link> 
                                </div>
                            </div>
                            <div className="info_social">
                                <Link className="socm1" to="https://www.instagram.comstatemovers?igsh=eXowc2R6ZWVxYWR1&utm_source=qr">
                                    <FontAwesomeIcon icon={faInstagram} title="Instagram" />
                                </Link>
                                <Link className="socm2" to="https://www.facebook.comstatemovers?mibextid=wwXIfr&mibextid=wwXIfr">
                                    <FontAwesomeIcon icon={faFacebook} title="Facebook" />
                                </Link>
                                <Link className="socm3" to="#">
                                    <FontAwesomeIcon icon={faYelp} title="Yelp" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-2 info_col ">
                            <h4>Location</h4>
                            <Map />
                        </div>
                    </div>
                </div>
            </section>

            <section className="footer_section">
                <div className="container">
                    <p>Copyright &copy;2024 | <b>Golden State Movers</b> |  All Rights Reserved </p>
                </div>
            </section>
        </div>
    );
}
export default Footer;